import { selectPPTAccountIsInCart } from '@/app/modules/ppt/state/entities/account/ppt-account.selectors';
import { selectPPTBillInCart, selectPPTBillIsByItselfPayable } from '@/app/modules/ppt/state/entities/bill/ppt-bill.selectors';
import { Injectable } from '@angular/core';
import { sync } from '@ces/sync';
import { Store } from '@ngrx/store';
import { State } from '@state/model';
import { Subject } from 'rxjs';
import { CartActionsFacade } from '../../cart/services/cart-actions.facade';

@Injectable({ providedIn: 'any' })
export class PPTCart
{

    constructor
    (
        // Dependencies

        private readonly store: Store<State>,
        private readonly cartActions: CartActionsFacade,
    )
    {}


    // API settings

    public static readonly BILL_CART_TYPE = 'ppt';
    public static readonly ACCOUNT_CART_TYPE = 'ppt-account';

    public toggleBillInCart(
        billId: string,
        notifyErrors: boolean = false,
        raiseAttention: boolean = true,
        retry: () => any = () => this.toggleBillInCart(billId, notifyErrors, raiseAttention)
    ): Subject<void>
    {
        const subject = new Subject<void>();
        
        // Check if bill is payable before adding to cart
        const isPayable = sync(this.store.select(selectPPTBillIsByItselfPayable(billId, true)));
        
        if (!sync(this.store.select(selectPPTBillInCart(billId))))
        {
            if (isPayable)
            {
                return this.cartActions.addItemsToCart(
                    [{ type: PPTCart.BILL_CART_TYPE, id: billId }],
                    raiseAttention,
                    notifyErrors,
                    retry,
                );
            }
            else
            {
                // Bill is not payable, return error
                setTimeout(() => 
{
                    subject.error(new Error('This bill cannot be added to the cart'));
                }, 0);
                return subject;
            }
        }
        else
        {
            return this.cartActions.removeItemsFromCart(
                [{ type: PPTCart.BILL_CART_TYPE, id: billId }],
                raiseAttention,
                notifyErrors,
                retry,
            );
        }
    }


    // Adding / Removing entire accounts

    public toggleAccountInCart(
        accountNumber: string,
        notifyErrors: boolean = false,
        retry: () => any = () => this.toggleAccountInCart(accountNumber, notifyErrors)
    ): Subject<void>
    {
        const isAccountInCart = sync(this.store.select(selectPPTAccountIsInCart(accountNumber)));

        if (!isAccountInCart)
            return this.cartActions.addItemsToCart(
                [{ type: PPTCart.ACCOUNT_CART_TYPE, id: accountNumber }],
                true,
                notifyErrors,
                retry,
            );
        else
            return this.cartActions.removeItemsFromCart(
                [{ type: PPTCart.ACCOUNT_CART_TYPE, id: accountNumber }],
                true,
                notifyErrors,
                retry,
            );
    }
}
